import { gql } from '@apollo/client';

export const SUBMIT_CLIENT_DETAIL_ADJUSTMENT = gql`
  mutation SubmitClientDetailAdjustment($billId: ID!, $fileBase64: String!) {
    submitClientDetailAdjustment(billId: $billId, fileBase64: $fileBase64) {
      taskId
      success
      errorMessage
    }
  }
`;

export interface SubmitClientDetailAdjustmentResponse {
  submitClientDetailAdjustment: {
    taskId: string | null;
    success: boolean;
    errorMessage: string | null;
  };
}
